import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../styles/forms.css';
import loaderStyles from '../Loader/loader.css';
var cxForm = classnames.bind(styles);
var cxLoader = classnames.bind(loaderStyles);
export default function Form(_ref) {
  var className = _ref.className,
      loading = _ref.loading,
      rest = _objectWithoutProperties(_ref, ["className", "loading"]);

  return React.createElement("form", _extends({
    className: classnames(cxForm('form'), cxLoader({
      loading: loading,
      lg: loading
    }), cxForm(className))
  }, rest));
}
Form.propTypes = {
  /** Class name to apply to component */
  className: PropTypes.string,

  /** Boolean indicating if a loading indicator should display */
  loading: PropTypes.bool
};
Form.defaultProps = {
  className: undefined,
  loading: false
};